export default "__VITE_ASSET__DZdrJIU___"